var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.184,
    height: 25.396,
    viewBox: "0 0 25.184 25.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-save-2644067",
    transform: "translate(-30.001 -25.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16682",
    "data-name": "Path 16682",
    d: "M54.522,31.456l-5.593-5.593a2.286,2.286,0,0,0-1.617-.663h-2.6v4.666a.883.883,0,0,1-.875.875H36.522a.883.883,0,0,1-.875-.875V25.2H32.281A2.28,2.28,0,0,0,30,27.48V48.316a2.28,2.28,0,0,0,2.28,2.28H52.9a2.28,2.28,0,0,0,2.28-2.28V33.073a2.287,2.287,0,0,0-.663-1.617Zm-4.745,14a.883.883,0,0,1-.875.875H36.257a.883.883,0,0,1-.875-.875V36.678a.883.883,0,0,1,.875-.875H48.9a.883.883,0,0,1,.875.875Z",
    fill: "#2b53bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16683",
    "data-name": "Path 16683",
    d: "M513.973,30.427H515.7a.351.351,0,0,0,.345-.345V26.4H513.6v3.685a.4.4,0,0,0,.371.345Z",
    transform: "translate(-472.918 -1.172)",
    fill: "#2b53bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16684",
    "data-name": "Path 16684",
    d: "M398.35,615.6h-7.423a.928.928,0,1,0,0,1.856h7.423a.928.928,0,1,0,0-1.856Z",
    transform: "translate(-352.046 -577.358)",
    fill: "#2b53bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16685",
    "data-name": "Path 16685",
    d: "M398.35,787.2h-7.423a.928.928,0,1,0,0,1.856h7.423a.928.928,0,1,0,0-1.856Z",
    transform: "translate(-352.046 -745.167)",
    fill: "#2b53bc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.132df49bf44da40a7b1cb050b21e737a.svg";
export { ForwardRef as ReactComponent };